import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { trackNow } from 'shared/models/analytic';

class Experiment extends React.Component {
  getChosenVariant() {
    const chosen = this.props.chosenVariant || this.props.defaultVariant;
    const children = [].concat(this.props.children);
    return _.find(children, c => c.props.name === chosen);
  }

  render() {
    return this.getChosenVariant() || null;
  }

  componentDidMount() {
    this.trackExperiment();
  }

  trackExperiment() {
    // Only track experiment once Google Optimize is done loading
    if (document.querySelector('.async-hide')) {
      window.setTimeout(() => this.trackExperiment(), 200);
      return;
    }

    trackNow('Experiment Viewed', {
      experimentName: this.props.name,
      variationName: this.props.chosenVariant || this.props.defaultVariant
    });
  }
}

const mapStateToProps = ({ app }, ownProps) => {
  const experiments = app.experiments || {};

  return {
    chosenVariant: experiments[ownProps.name]
  };
};

export default connect(mapStateToProps)(Experiment);
